import { CertificateFormVM } from 'front-office/view-models/certificate/certificate-form';
import { RequestCertificate } from 'shell/models/certification';
import { User } from 'shell/models/user';

export const transformRequestCertificateData = (
  values: CertificateFormVM,
  datiLogin?: User
): RequestCertificate => {
  let accountholder = {};

  const hasGenerality =
    (values.generality &&
      (values.applicant?.fiscalCode || values.applicant?.name || values.applicant?.surname)) ||
    values.applicant;

  const generalitaRichiedente = hasGenerality
    ? {
        docRiconoscimento:
          values.generality?.dateReleaseDocument || values.generality?.numberDocument
            ? {
                dataRilascio: values.generality?.dateReleaseDocument?.toFormat('yyyy-MM-dd'),
                estDocRiconoscimento: values.generality?.numberDocument,
              }
            : undefined,
        generalita: hasGenerality
          ? {
              idSchedaSoggettoANPR: values.generality?.idSubjectAnpr || undefined,
              codiceFiscale: values.applicant?.fiscalCode
                ? {
                    codFiscale: values.applicant?.fiscalCode,
                  }
                : undefined,
              nome: values.applicant?.name,
              cognome: values.applicant?.surname,
              senzaNome: values.applicant?.withoutName ? '1' : undefined,
              senzaCognome: values.applicant?.withoutSurname ? '1' : undefined,
              sesso: values.applicant?.gender,
              dataNascita: values.generality?.birthDate?.toFormat('yyyy-MM-dd'),
              senzaGiorno:
                !values.generality?.birthChoiceDate?.includes('day') &&
                values.generality?.birthChoiceDate?.includes('month')
                  ? '1'
                  : undefined,
              senzaGiornoMese:
                !values.generality?.birthChoiceDate?.includes('day') &&
                !values.generality?.birthChoiceDate?.includes('month') &&
                values.generality?.birthDate
                  ? '1'
                  : undefined,
              luogoNascita:
                values.generality?.municipalityOfBirth || values.generality?.foreignStateBirth
                  ? {
                      comune:
                        !values.generality?.isForeign && values.generality?.municipalityOfBirth
                          ? {
                              nomeComune: values.generality?.municipalityOfBirth?.description,
                              siglaProvinciaIstat: values.generality?.municipalityOfBirth?.province,
                              descrizioneLocalita: values.generality?.locality,
                            }
                          : undefined,
                      localita:
                        values.generality?.isForeign && values.generality?.foreignStateBirth
                          ? {
                              codiceStato: values.generality?.foreignStateBirth?.id,
                              descrizioneStato: values.generality?.foreignStateBirth?.value,
                              provinciaContea: values.generality?.foreignStateBirth?.province,
                              descrizioneLocalita:
                                values.generality?.foreignMunicipality?.description,
                            }
                          : undefined,
                    }
                  : undefined,
            }
          : undefined,
      }
    : undefined;

  if (values.accountholder?.sameApplicant) {
    accountholder = {
      generalita: {
        ...(generalitaRichiedente?.generalita || {}),
      },
    };
  } else {
    accountholder = {
      generalita: {
        idSchedaSoggettoANPR: values.accountholder?.account?.generality?.idSubjectAnpr || undefined,
        codiceFiscale: {
          codFiscale: values.accountholder?.account?.applicant?.fiscalCode,
        },
        nome: values.accountholder?.account?.applicant?.name,
        cognome: values.accountholder?.account?.applicant?.surname,
        senzaNome: values.accountholder?.account?.applicant?.withoutName ? '1' : undefined,
        senzaCognome: values.accountholder?.account?.applicant?.withoutSurname ? '1' : undefined,
        sesso: values.accountholder?.account?.applicant?.gender || '',
      },
    };
  }

  const { modality } = values;

  const {
    amountTaxStamp = 0.0,
    amountRightsSecretariat = 0.0,
    amountRightsCivilState = 0.0,
    amountFixedRights = 0.0,
    amountExpenses = 0.0,
    codeExemptionAnpr,
    descrizioneModalitaStampa = '',
  } = modality || {};

  const rights =
    amountExpenses + amountFixedRights + amountRightsCivilState + amountRightsSecretariat;

  // const [name, surname] = datiLogin?.name.split('.') || ''.split('.');

  return {
    usoInterno: values.certificateInternOnly,
    generalitaRichiedente,
    motivoRilascio: values.accountholder?.account?.applicant?.releaseReason || undefined,
    soggettoIntestatario: accountholder,
    testataRichiesta: {
      dataOraRichiesta: values.dateForm?.toFormat('yyyy-MM-dd'),
      dataDecorrenza: values.dateForm?.toFormat('yyyy-MM-dd'),
    },
    datiControllo: {
      tipoFirmaElettorale: values.certificateAnpr?.some(
        (el) =>
          (el.key.codiceDocumento === '21' || el.key.codiceDocumento === '22') &&
          el.key.tipoDocumento === 'CA'
      )
        ? '1'
        : undefined,
      // manca cognome e nomeUff anagrafe
      cognomeUffAnagrafe: '-',
      nomeUffAnagrafe: datiLogin?.nome || '-',
      tipoRichiedente: values.accountholder?.sameApplicant || !hasGenerality ? '2' : '1',
      descrizioneEsenzioneBollo: codeExemptionAnpr === '99' ? descrizioneModalitaStampa : undefined,
      tipoRichiesta: values.generality ? '1' : '2', // emissione certificato
      paEstera: values.intendedUse,
      emissione: '1', // sportello
      bollo:
        amountTaxStamp && !values?.certificateInternOnly
          ? amountTaxStamp.toFixed(2).replace(/[,.]/gi, '')
          : '0',
      bolloVirtuale: amountTaxStamp ? '1' : '0', // Bollo assolto in maniera virtuale
      diritti: values?.certificateInternOnly ? '0' : rights.toFixed(2).replace(/[,.]/gi, ''),
      esenzioneBollo: codeExemptionAnpr, // TODO
      forzaCertificazione: values.withReports === 'N' || !values.withReports ? '0' : '1',
      listaAnnotazioni: {
        rigaAnnotazione: [
          codeExemptionAnpr === '99' ? descrizioneModalitaStampa : null,
          null,
          null,
        ],
      },
    },
    tipoPagamento: values.typePayment,
    // TODO lista lingua certificati e tipi certificato
    listaTipiCertificati: {
      tipoCertificato: values.certificateAnpr?.map((element) => element.key?.codiceDocumento) || [],
    },
    //listaTipoDocumento => Array<CertificateTypeANPRList>
    tipoDocumento: values.certificateAnpr,
    // modalita rilascio
    codiceModalitaRilascio: modality?.id as string,
    linguaCertificato: { tipoLinguaCertificato: ['IT'] }, // Fisso ad IT
  };
};
